import React from 'react';
import { Tooltip, IconButton } from '@mui/joy';
import { Info } from '@mui/icons-material';

interface InfoTooltipComponentProps {
    message: string;
    size?: 'sm' | 'md' | 'lg';
    variant?: 'plain' | 'outlined' | 'soft' | 'solid';
    color?: 'primary' | 'success' | 'warning' | 'danger' | 'neutral';
}

function InfoTooltipComponent({
    message,
    size = 'sm',
    variant = 'plain',
    color = 'neutral'
}: InfoTooltipComponentProps) {
    return (
        <Tooltip
            title={message}
            variant="solid"
            placement="top"
            sx={{
                fontSize: '0.75rem',
                padding: '0.5rem',
                borderRadius: '0.25rem',
                backgroundColor: '#333',
                color: '#fff',
                maxWidth: '200px',
                textAlign: 'center'
            }}
        >
            <IconButton
                size={size}
                variant={variant}
                sx={{
                    minWidth: 'auto',
                    minHeight: 'auto',
                    cursor: 'help',
                    marginLeft: 1,
                    color: '#a1a1a1',
                }}
            >
                <Info sx={{ fontSize: '0.95rem' }} />
            </IconButton>
        </Tooltip>
    );
}

export default InfoTooltipComponent;
